<div class="kz-projectV2">
  <div class="kz-projectV2-container">
    <div class="kz-projectV2-content">

      <div  class="kz-registerV2-form-header">
        <div class="kz-registerV2-form-header-title">
          <h2 *ngIf="step == 1" i18n="@@auth.tags1.title">Your works</h2>
          <h2 *ngIf="step == 2" i18n="@@auth.tags2.title">Your layout</h2>
          <p i18n="@@auth.tags.subTitle">Select the thumbnails that define your project</p>
        </div>
        <div *ngIf="isInKazaplan$ | async" class="kz-registerV2-from-plan">
          <kz-jumbotron jumbotronContext="warning">
            <h3 class="kz-light-title">
              <kz-icons name="infos" inline="true"></kz-icons>
              <ng-container i18n="@@auth.kaza.fromKazaplan">Finalize your registration to save your 3D plan</ng-container>
            </h3>
          </kz-jumbotron>
        </div>

      </div>

      <form [formGroup]="tagsForm" (ngSubmit)="save()" class="kz-registerV2-form" [appGtmTrack]="gtmForm" trackChildren="false">
        <div *ngIf="loadingTags" class="kz-registerV2-loader">
          <kz-loader type="logo"></kz-loader>
        </div>

        <ul class="kz-projectV2--categories">
          <li *ngFor="let tag of tags; let i = index" class="kz-registerV2--category">
            <input class="kz-choice-grid-input" type="checkbox" id="kz-choice-{{i}}" [formControl]="tagsForm.get('tags')['controls'][i]"/>
            <label class="kz-choice-grid-label" for="kz-choice-{{i}}">
              <span kzBadge badgeType="certified" title="team kozikaza" [empty]="true"></span>
              <img src="{{ tag?.media?.thumbs?.big }}" alt="{{ tag.name }}" height="120" />
              <span class="option-title">{{ tag.name }}</span>
            </label>
          </li>
        </ul>

        <span *ngIf="isFieldInvalid('tags')" kzError><span i18n="@@auth.tags.errors.required">Please select at least one type of renovation</span></span>

        <div class="kz-field-buttons ">
          <button type="button" kzButton buttonStyle="flat" (click)="previous()" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted" i18n="@@auth.button.previous" ><span >Previous</span></button>
        <div>
          <button type="button" kzButton buttonStyle="borderless" (click)="cancel()" i18n="@@auth.button.cancel" [disabled]="submitted" appGtmTrack="{{ gtmCancel }}">Cancel</button>
          <button type="submit" kzButton buttonStyle="flat" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted" appGtmTrack="{{ gtmSubmit }}" data-cy="submit"><span i18n="@@auth.button.next">Next</span></button>
        </div>
        </div>
      </form>
    </div>
    <app-legal-notice [whiteTxt]="true"></app-legal-notice>
  </div>
</div>

